import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import useProcessData from "../../../../CommonFunction/ProcessData";
import { LoadTable, Loading } from "../../../Components";
import HeaderDiv from "../../../Components/HeaderDiv/HeaderDiv";
import { ErrorToast } from "../../../Components/ToastComponent/RectHotToast";
import useFetchTableData from "../../../custom_hooks/useFetchTableData";

const queryfunction = (fields) => {
  const query = gql`
  query getAgaintRefWithNewRefByID($id: ID!) {
    GetAgaintRefWithNewRefByID(id: $id) {
    _id
    ${fields?.join(" ")}
  }
}`;
  return query;
};

const AgainstReferences = () => {
  const [formData, setFormData] = useState([]);
  const [isLoader, setIsLoader] = useState(true);
  let { id, title } = useParams();

  const config = useMemo(
    () => ({
      dataKey: "GetAgaintRefWithNewRefByID",
      dateKeys: ["createdAt", "updatedAt", "RefDate", "Date"],
      deleteKeys: ["__typename"],
    }),
    []
  );

  const [fetchPayable_GetAgaintRefWithNewRefByID, { loading: queryLoading, error, data }] = useLazyQuery(
    queryfunction([]),
    {
      variables: {
        id: id,
      },
      fetchPolicy: "network-only",
      onCompleted: () => {
        setIsLoader(false);
      },
      onError: () => {
        setIsLoader(false);
      },
    }
  );

  useEffect(() => {
    if (error) {
      ErrorToast(error.message);
    }
  }, [error]);

  const { loading, TableHeaders } = useFetchTableData(
    queryfunction,
    fetchPayable_GetAgaintRefWithNewRefByID,
    setIsLoader,
    `${title}_References`
  );

  const { loading: processDataLoading } = useProcessData(data, setFormData, config, error);

  const isLoading = queryLoading || processDataLoading || isLoader;
  console.log(`${title}_References`);
  return (
    <div>
      <HeaderDiv title="Against References" MoreActions={{ Is_Back: true, Is_Forword: false }} />
      {isLoading || loading ? (
        <Loading />
      ) : !formData?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <LoadTable
          title={`${title}_References`}
          data={formData}
          loading={loading}
          error={error}
          TableHeaders={TableHeaders}
        />
      )}
    </div>
  );
};

export default AgainstReferences;
